import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import useGlobalState from '../../GlobalStateContext';

import { GetAdminResponse } from 'Api/CRM/Responses/AdminResponse';
import Admin from 'Api/Models/Admin';
import SubmitButton from 'crm/elements/formElements/SubmitButton';
import { ValidationErrors } from 'crm/helpers/ResponseErrorHelper';
import useCountriesAndStates from 'crm/hooks/useCountriesAndStates';
import useSmartField, { FieldChangeCallback } from 'crm/hooks/useSmartField';

type Props = Readonly<{
    action: (superAgentData: GetAdminResponse) => void;
    superAgentData: GetAdminResponse;
    errors: ValidationErrors;
}>;

export default function SuperAgentForm({ action, superAgentData, errors }: Props) {
    const [superAgent, setSuperAgent] = useState<Admin>(new Admin(superAgentData ?? {}));
    const history = useHistory();
    const { loggedAdmin } = useGlobalState();
    const [countries, states] = useCountriesAndStates(superAgent.country);

    useEffect(() => {
        setSuperAgent(new Admin(superAgentData ?? {}));
    }, [superAgentData]);

    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        action(superAgent);
    }

    const handleFieldChange: FieldChangeCallback = (name, value) =>
        setSuperAgent((prevAdmin) => prevAdmin.getNew({ [name]: value }));

    const Field = useSmartField({ errors, onChange: handleFieldChange });

    return (
        <form onSubmit={handleSubmit} autoComplete="do-not-autofill">
            <Field name="name" value={superAgent.name} />
            <Field type="email" name="email" value={superAgent.email} />
            <Field type="password" name="password" value={superAgent.password} disableAutofill />
            <Field type="select" name="country" value={superAgent.country} options={countries} />
            <Field type="select" name="state" value={superAgent.state} options={states} />
            {loggedAdmin.isSuperAdmin() && (
                <Field
                    type="number"
                    name="reseller_percent_revenue"
                    label="Reseller revenue"
                    value={superAgent.reseller_percent_revenue}
                />
            )}
            <button type="button" onClick={() => history.push('/super_agents')} className="btn btn-secondary">
                Cancel
            </button>
            <SubmitButton label="Save" />
        </form>
    );
}
